'use strict';

angular.module('internal.inspections')
    .controller('InternalInspection', ['$scope', '$stateParams', 'IPInspections', '$state', '$rootScope', function ($scope, $stateParams, IPInspections, $state, $rootScope) {
        $scope.masterInspection = $stateParams.inspection;
        $scope.inspection = $stateParams.inspection;
        $scope.inspectionID = $stateParams.id;
        $scope.enterpriseID = $rootScope.enterpriseID;
        $scope.inspectionLoading = true;

        $scope.setMasterInspection = function (inspection) {
            $scope.masterInspection = inspection;
            $scope.inspection = angular.copy($scope.masterInspection);
        }

        $scope.resetInspection = function () {
            if ($scope.masterInspection == null) {
                $scope.masterInspection = {};
            }
            $scope.inspection = angular.copy($scope.masterInspection);
        }

        $scope.getInspection = function () {
            $scope.inspectionLoading = true;

            IPInspections.getByID($stateParams.id).then(function (inspection) {
                $scope.inspectionLoading = false;
                $scope.setMasterInspection(inspection);

                $scope.inspectionColumns = [
                    {
                        label: $rootScope.enterprise.serviceLabels['SERVICE'] + '/' + $rootScope.enterprise.vehicleLabels['VEHICLE'],
                        field: 'name',
                        link: {
                            state: 'internal.inspecting.inspection.related',
                            params: [
                                {
                                    name: 'id',
                                    field: 'id'
                                },
                                {
                                    name: 'inspection',
                                    field: ''
                                }
                            ]
                        },
                        document: {
                            id: 'checklist.document.id',
                            code: 'checklist.document.code',
                            url: $rootScope.internalURL + 'controller.cfm?method=publicPortalService.openDocument'
                        },
                        classes: [
                            {
                                name: 'green',
                                field: inspection.id
                            },
                            {
                                name: 'red',
                                field: inspection.reinspection_id
                            }
                        ],
                        info: [
                            {
                                label: 'Unit Number',
                                field: 'vehicle.unit_number'
                            },
                            {
                                label: 'Call Sign',
                                field: 'vehicle.call_sign'
                            }
                        ]
                    },
                    {
                        label: 'Number',
                        field: 'number'
                    },
                    {
                        label: 'Inspector',
                        field: 'inspector_show'
                    },
                    {
                        label: 'Status',
                        field: 'status.name'
                    },
                    {
                        label: '',
                        field: 'checklist.deficiencies_fail_show',
                        type: 'deficiency_total'
                    }
                ]
            });
        }
        if ($stateParams.id != null) {
            $scope.getInspection();
        }
        else {
            $state.go('internal.inspecting.denied');
        }
    }])
;